// extracted by mini-css-extract-plugin
    if(module.hot) {
      // 1791793626675
      var cssReload = require("D:/BuildAgent/work/136/s/Yahome.RecruitSystem.Web/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"hmr":true,"publicPath":"../","locals":false});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  